<template>
  <div v-if="!linkIsSupplierCentral">
    <a
       :href="hrefUrl"
       target='_blank'
       :class="isSearchTitle ? 'search-result-title' : ''"
    ><slot></slot>
      <font-awesome-icon class="ml-1"
                         icon="external-link-alt"/>
    </a>
  </div>
  <div v-else @click="clearSearchTermAndNavigate">
    <slot></slot>
  </div>

</template>

<script>

import Vue from "vue";

export default {
  name: "ShowExternalLink",
  props: ["hrefUrl","isSearchTitle"],
  computed: {
    linkIsSupplierCentral() {
      return this.hrefUrl.includes('/supplier-central')
    }
  },
  methods: {
    clearSearchTermAndNavigate() {
      this.$emit('onClearSearchTerm')
      let that = this
      Vue.nextTick(function () {
        window.location.href = that.hrefUrl
      })
    }
  }
}

</script>

<style scoped>
.search-result-title {
  color: #0696d7;
  font-family: artifaktElementBold;
  font-size: 14px;
  font-weight: bold;
}
</style>